// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"17baf333","455":"5a259904","977":"5ac2d104"}[chunkId] + ".chunk.js";
};